import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from '../../providers/auth';
import { debounceTime } from 'rxjs/operator/debounceTime';
import { Subject } from 'rxjs/Subject';
import { NgxSpinnerService } from 'ngx-spinner';
import { AsyncLocalStorage } from 'angular-async-local-storage';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private router: Router, private spinner: NgxSpinnerService,
    private auth: Auth
    ) {
    this.route.queryParams.subscribe(params => {
      const noesys = params['noesys'];
      if (noesys === '1') {
        this.isNoesys = true;
        console.log('this.isNoesys: ' + this.isNoesys);
        localStorage.setItem('isNoesys', '1');
      } else if (localStorage.getItem('isNoesys') === '1') {
        this.isNoesys = true;
      }
    });
  }

  private _success = new Subject<string>();
  successMessage: string;
  alertType: string = 'danger';

  username;
  password;
  remenber = true;
  isNoesys = false;
  showResend = false;
  resendEmail: string | null = null;
  resendLoading = false;
  resendSuccess: string | null = null;
  showPassword = false;

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  login() {
    if (!this.username || !this.password) {
      this._success.next('Información incompleta. Debe agregar su usuario y contraseña');
    } else {
      const body = {
        username: this.username,
        pass: this.password,
        remember: this.remenber
      };
      this.spinner.show();
      this.showResend = false;
      this.resendSuccess = null;
      this.auth.login(body).subscribe((res: any) => {
        console.log(res);
        if (res) {
          this.auth.loginIn(res.data).subscribe(() => {
            this.router.navigate(['home']);
          }, (err) => {
            console.log(err);
            console.log('Ha ocurrido un error al guardar el usuario');
          });
        } else {
          console.log('no hay respuesta');
        }
        this.spinner.hide();
      }, err => {
        console.error('ERROR', err);
        this.alertType = 'danger';
        var isNotActivated = err.error && (err.error.error === 'email_not_activated' || err.error.activated === false || err.error.resend === true);
        if (isNotActivated) {
          this.showResend = true;
          this.resendEmail = (err.error && err.error.email) ? err.error.email : this.username;
          this._success.next(err.error && err.error.message ? err.error.message : 'Su cuenta no ha sido activada. Revise su email para activarla.');
        } else {
          this.showResend = false;
          this._success.next(err.error && err.error.message ? err.error.message : 'Error al iniciar sesión');
        }
        this.spinner.hide();
      });
    }
  }

  resendActivation() {
    if (!this.resendEmail) { this.resendEmail = this.username; }
    if (!this.resendEmail) { return; }
    var self = this;
    this.resendLoading = true;
    this.resendSuccess = null;
    this.auth.resendActivation(this.resendEmail).subscribe(function(res: any) {
      self.resendLoading = false;
      self.alertType = 'success';
      self.resendSuccess = 'email resent';
      self._success.next('email resent');
      setTimeout(function() { self.resendSuccess = null; }, 10000);
    }, function(err: any) {
      self.resendLoading = false;
      self.alertType = 'danger';
      self._success.next(err.error && err.error.message ? err.error.message : 'Error al reenviar activación');
    });
  }

  onKeydown(event) {
    if (event.key === 'Enter') {
      this.login();
    }
  }

  ngOnInit(): void {

    // msg de error en login
    this._success.subscribe((message) => this.successMessage = message);
    debounceTime.call(this._success, 10000).subscribe(() => this.successMessage = null);

    // Si viene de registro exitoso, mostrar mensaje
    if (this.route.snapshot.queryParams['registered'] === '1') {
      this.alertType = 'success';
      this._success.next('Cuenta creada exitosamente. Revise su email para activarla.');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/login/login.component.ts